import LoginPage from "@/app/login/page";
import { mountPublicPage } from "./mount";

mountPublicPage(<LoginPage />);
